var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLouisianaRub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "louis-path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1341352,33.3998 C32.1341352,33.3998 33.4159583,37.4423236 30.1820365,37.4423236 C27.1010016,37.4423236 27.4320139,34.7854892 27.4708423,34.5326191 L30.5416847,34.5326191 C30.5426554,34.5326191 30.5431408,34.5321338 30.5431408,34.5316484 L30.5431408,33.3041851 C30.5431408,33.3032143 30.5426554,33.3022436 30.5416847,33.3022436 L29.6263048,33.3022436 L27.626156,33.3022436 C27.626156,33.3022436 28.4017536,27.4008096 33.9187863,27.4008096 C39.4363044,27.4008096 37.483235,32.8358173 37.483235,32.8358173 C37.483235,32.8358173 42.1868124,32.0053745 42.1868124,27.3940146 C42.1868124,23.7538505 38.9912337,21.7289485 36.0659978,21.7289485 C31.2255502,21.7289485 26.6030272,26.5082413 26.6030272,32.4315164 C26.6030272,32.7353487 26.6098221,33.0207376 26.6185585,33.3022436 L25.7915132,33.3022436 C26.2273622,22.915642 29.6263048,24.1416493 29.6263048,18.3702904 C29.6263048,12.7324043 24.9998989,6.25 24.9998989,6.25 L24.9994135,6.25 C24.9994135,6.25 20.373493,12.7324043 20.373493,18.3702904 C20.373493,24.1416493 23.7719502,22.915642 24.2073138,33.3022436 L23.3807539,33.3022436 C23.3894903,33.0207376 23.3962853,32.7353487 23.3962853,32.4315164 C23.3962853,26.5082413 18.7732768,21.7289485 13.9333146,21.7289485 C11.0075934,21.7289485 7.8125,23.7538505 7.8125,27.3940146 C7.8125,32.0053745 12.5160774,32.8358173 12.5160774,32.8358173 C12.5160774,32.8358173 10.563008,27.4008096 16.0805261,27.4008096 C21.5980442,27.4008096 22.3731565,33.3022436 22.3731565,33.3022436 L20.373493,33.3022436 L19.4576277,33.3022436 C19.456657,33.3022436 19.4556863,33.3032143 19.4556863,33.3041851 L19.4556863,34.5316484 C19.4556863,34.5321338 19.456657,34.5326191 19.4576277,34.5326191 L22.5284701,34.5326191 C22.5672985,34.7854892 22.8978254,37.4423236 19.8177613,37.4423236 C16.5833541,37.4423236 17.8651772,33.3998 17.8651772,33.3998 C17.8651772,33.3998 15.1534976,33.4813397 15.1534976,36.5550943 C15.1534976,38.6581384 16.9129103,40.0778024 18.9795528,40.0778024 C21.4106971,40.0778024 22.9526706,38.7707408 23.3137749,34.5326191 L24.2437155,34.5326191 C24.2500251,34.8796481 24.2539079,35.2344427 24.2539079,35.6047688 C24.2539079,38.9716779 23.0453734,40.9781364 23.0453734,40.9781364 C24.9188446,40.4442456 24.9974721,43.3583183 24.9994135,43.75 L24.9998989,43.75 C25.0018403,43.3583183 25.0804679,40.4442456 26.953939,40.9781364 C26.953939,40.9781364 25.7454045,38.9716779 25.7454045,35.6047688 C25.7454045,35.2344427 25.7492873,34.8796481 25.755597,34.5326191 L26.6855375,34.5326191 C27.0461565,38.7707408 28.5886153,40.0778024 31.0197596,40.0778024 C33.0864021,40.0778024 34.8458148,38.6581384 34.8458148,36.5550943 C34.8458148,33.4813397 32.1341352,33.3998 32.1341352,33.3998",
    id: "louis-path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "louis-Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "louis-Screen-2",
    transform: "translate(-59.000000, -1774.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "louis-New",
    transform: "translate(59.000000, 1774.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "louis-Rectangle-12",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("g", {
    id: "louis-\\u2747\\uFE0F--Shape-/-Circle-/-Color_Solid"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "louis-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#louis-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "louis-Oval",
    fill: "#006938",
    fillRule: "evenodd",
    xlinkHref: "#louis-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "louis-\\uD83C\\uDFA8--Color-/-Primary-/-Green-/-100%",
    mask: "url(#louis-mask-2)",
    fill: "#006938",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "louis-mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#louis-path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "louis-Fill-1",
    fill: "#231F20",
    xlinkHref: "#louis-path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "louis-\\uD83C\\uDFA8--Color-/-Secondary-/-White-/-100%",
    mask: "url(#louis-mask-4)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLouisianaRub);
export default __webpack_public_path__ + "static/media/LouisianaRub.2eb0016703888fb64b3d0bfeb0b44282.svg";
export { ForwardRef as ReactComponent };